import { db } from '../utils/firebase';

export const getIntroduction = async () => {
  const introduction = db.collection("contact").doc("introduction");
  const doc = await introduction.get();
  const { image, content } = doc.data();

  return { url: image, content };
}

export const getContactInfo = async () => {
  const contact = db.collection("contact").doc("contact");
  const doc = await contact.get();
  const { location, number } = doc.data();

  return { location, number };
}

export const getResearchers = async () => {
  const researchers = db.collection("contact").doc("researchers");
  // get title
  const doc = await researchers.get();
  const { introduction, title } = doc.data();
  // get childrens
  const children = [];
  const querySnapshot = await researchers.collection("children").get();
  querySnapshot.forEach(doc => {
    const { subtitle, content, order } = doc.data();
    children.push({ subtitle, content, order });
  });

  children.sort((a, b) => a.order - b.order)

  return { introduction, title, researchers: children };
}

export const getParticipants = async () => {
  const participants = db.collection("contact").doc("participants");
  const doc = await participants.get();
  const { content } = doc.data();

  return { content };

}
